<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="date"
      :nudge-right="40"
      :nudge-top="-5"
      transition="scale-transition"
      min-width="auto"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="computedDateFormatted"
          :placeholder="placeholderprops"
          :rules="rules"
          outlined
          v-bind="attrs"
          v-on="on"
          :dense="dense"
          :label="label"
          readonly
          hide-details
          prepend-inner-icon="mdi-calendar"
          clearable
          @click:clear="onClear"
        />
      </template>
      <v-date-picker v-model="date" locale="vi" color="#FBB040" no-title scrollable>
        <v-spacer />
        <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
        <v-btn text color="primary" @click="onChange(date)"> OK </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import { EMPTY } from "~/utils/constants";
import { parseDate, formatDate } from "~/utils";

export default {
  name: "DatePicker",
  props: {
    label: {
      type: String,
      default: EMPTY,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
    placeholderprops: {
      type: String,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      menu: false,
      date: null,
    };
  },
  computed: {
    computedDateFormatted() {
      return formatDate(this.date);
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.date = parseDate(newVal);
      },
      immediate: true,
    },
  },
  methods: {
    onClear() {
      this.$refs.menu.save(null);
      this.$emit("input", null);
    },
    onChange(date) {
      this.$refs.menu.save(date);
      this.$emit("input", this.computedDateFormatted);
    },
  },
};
</script>
